import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function cekMitra(params) {
    return client.get("/tunnel/api/pos/transaction/check_member", {
        params: params,
    });
}

function dataTransaction(params) {
    return client.get("tunnel/api/pos/transaction/data", {
        params: params,
    });
}

function detailTransaction(params) {
    return client.get("tunnel/api/pos/transaction/detail", {
        params: params,
    });
}

function dataSerial(params) {
    return client.get("tunnel/api/pos/transaction/serial", {
        params: params,
    });
}

function transaksiMitra(params) {
    return client.post("tunnel/api/pos/transaction/transactionmember", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

function transaksiMitraBaru(params) {
    return client.post("tunnel/api/pos/transaction/transactionregister", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

function dataOptionSerial(params) {
    return client.get("tunnel/api/pos/transaction/data-option-serial", {
        params: params,
    });
}

function registerItem() {
    return client.get("tunnel/api/pos/transaction/register-item");
}

function formatSerialString(params) {
    return client.get("tunnel/api/pos/transaction/format-serial", {
        params: params,
    });
}

function checkSerialMLM(params) {
    return client.get("tunnel/api/pos/transaction/check-serial/serial", {
        params: params,
    });
}

function getMemberHasTransaction (params) {
    return client.get("tunnel/api/pos/transaction/member-transaction-list", {
        params: params,
    });
}

function getBvStockist (params) {
    return client.get("tunnel/api/pos/transaction/bv-digital", {
        params: params,
    });
}

function getSerialDigitalAvailable (params) {
    return client.get("tunnel/api/pos/transaction/get-bv-available", {
        params: params,
    });
}

function checkPinTransaction(params) {
    return client.post("tunnel/api/pos/transaction/check-stockist-pin", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

export default {
    cekMitra,
    detailTransaction,
    dataTransaction,
    transaksiMitra,
    transaksiMitraBaru,
    dataSerial,
    dataOptionSerial,
    registerItem,
    formatSerialString,
    checkSerialMLM,
    getMemberHasTransaction,
    getBvStockist,
    getSerialDigitalAvailable,
    checkPinTransaction
};
